import { render } from "./CheckboxCard.vue?vue&type=template&id=90b8f21a&scoped=true"
import script from "./CheckboxCard.vue?vue&type=script&lang=js"
export * from "./CheckboxCard.vue?vue&type=script&lang=js"

import "./CheckboxCard.vue?vue&type=style&index=0&id=90b8f21a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b8f21a"]])

export default __exports__